// src/components/About.js
import React, { useState, useEffect, useRef } from 'react';
import './About.css'; // Import CSS for styling
import DoubleBox1 from './DoubleBox1'; // Import DoubleBox1
import DoubleBox2 from './DoubleBox2'; // Import DoubleBox2
import DynamicInfo from './DynamicInfo'; // Import DynamicInfo

const About = () => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isVisible, setIsVisible] = useState(false); // Track if section is in view
  const sectionRef = useRef(null); // Reference to the section for Intersection Observer

  const calculateTimeLeft = () => {
    // Updated target date to November 19, 2026
    const targetDate = new Date('2026-11-19T00:00:00');
    const now = new Date();
    const difference = targetDate - now;

    if (difference > 0) {
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / (1000 * 60)) % 60);
      const seconds = Math.floor((difference / 1000) % 60);
      return { days, hours, minutes, seconds };
    } else {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true); // Trigger animations when in view
          }
        });
      },
      { threshold: 0.2 } // Trigger when 20% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div
      id="about"
      className={`section ${isVisible ? 'visible' : ''}`}
      ref={sectionRef}
    >
      <h1 className="title">Countdown</h1>

      <div className="about-box full-width-box">
        <div className="countdown-container">
          <div className="countdown-box">
            <h2>{timeLeft.days}</h2>
            <p>Days</p>
          </div>
          <div className="countdown-box">
            <h2>{timeLeft.hours}</h2>
            <p>Hours</p>
          </div>
          <div className="countdown-box">
            <h2>{timeLeft.minutes}</h2>
            <p>Minutes</p>
          </div>
          <div className="countdown-box">
            <h2>{timeLeft.seconds}</h2>
            <p>Seconds</p>
          </div>
        </div>
      </div>

      <div className="about-box-row">
        <DoubleBox1 /> {/* First half-width box */}
        <DoubleBox2 /> {/* Second half-width box */}
      </div>

      <DynamicInfo /> {/* Render the DynamicInfo component */}
    </div>
  );
};

export default About;